
import React from 'react';

const CustomSolutionsIntegration = () => {
  return (
    <section className="py-20 bg-[#1A1F2C] text-white">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-10">
            Seamless Integration with <span className="text-gradient">Your Existing Systems</span>
          </h2>
          
          <p className="text-xl mb-6 font-medium text-white/90">
            No rip-and-replace. No disruption. Just smarter, faster operations.
          </p>
          
          <p className="text-lg text-gray-300 leading-relaxed">
            We design custom solutions that work with your existing systems — not against them. 
            Whether it's your CRM, document management platform, case management software, or 
            internal databases, DocketLabs ensures your new automations integrate smoothly into 
            the tools and workflows you already trust.
          </p>
        </div>
        
        {/* Tech-inspired decorative elements */}
        <div className="mt-16 flex justify-center">
          <div className="grid grid-cols-3 gap-6 max-w-3xl">
            {[...Array(6)].map((_, index) => (
              <div
                key={index}
                className="aspect-square relative overflow-hidden rounded-lg bg-white/5 border border-white/10 group hover:bg-white/10 transition-all"
              >
                <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-br from-blue-500/20 via-transparent to-purple-500/20 opacity-0 group-hover:opacity-100 transition-opacity"></div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-1/2 h-1/2 rounded-md border border-white/20"></div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CustomSolutionsIntegration;
